<template>
  <span :style="iconStyle" class="unicode-icon">
    {{ icon }}
  </span>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  interface Props {
    icon: string
    bold?: boolean
    size?: number | string
    color?: string
  }

  const props = defineProps<Props>()

  const iconStyle = computed(() => {
    const fontWeight = props.bold ? '900' : '400'

    const fontSize =
      typeof props.size === 'number'
        ? `${props.size}px`
        : props.size || '1.5rem'

    return {
      fontWeight,
      fontSize,
      color: props.color ?? 'inherit',
      lineHeight: 1,
      display: 'inline-block'
    }
  })
</script>

<style scoped>
  .unicode-icon {
    user-select: none;
    line-height: 1;
  }
</style>

<style>
  p>.unicode-icon {
    vertical-align: middle !important;
    transform: translateY(-0.08em);
  }

  span>.unicode-icon {
    vertical-align: middle !important;
  }
</style>
